<li
  (click)="dateClicked(date)"
  class="dc-date-form-li nav-link p-1"
  [ngClass]="{
    active: date === selectedDate,
    'dc-date-form': date !== selectedDate
  }"
>
  <div class="d-flex justify-content-between">
    <button
      class="btn btn-icon rounded-circle btn-sm btn-soft-primary"
      (click)="removeDate(index)"
      type="button"
    >
      <i
        role="img"
        class="fa fa-trash"
        attr.aria-label="{{ 'general.delete' | translate }}"
      ></i>
    </button>
    <span class="text-primary align-self-center fw-bold px-2">
      {{
        date
          | dateFromMoment
          | date : 'EEE, d MMM yyyy' : undefined : selectedLanguage
      }} </span
    ><span
      class="badge btn-icon rounded-circle btn-sm me-lg-1"
      [ngClass]="{
        'bg-soft-success': isFormValid,
        'bg-soft-danger': !isFormValid
      }"
    >
      <i
        class="fa"
        [ngClass]="{
          'fa-check': isFormValid,
          'fa-question': !isFormValid
        }"
        role="img"
        [attr.aria-label]="
          isFormValid
            ? ('general.approved' | translate)
            : ('surveryModule.question' | translate)
        "
      ></i>
    </span>
  </div>
  <small class="d-block mb-0 text-center" *ngIf="errorMessage">{{
    errorMessage | translate
  }}</small>
  <ng-content></ng-content>
</li>
